import { LOCALES, type Locale } from "@/domain/localized";

const SUPPORTED = new Set<string>(LOCALES);
/** Countries where Russian is the default when the device language is not one we ship. */
const RUSSIAN_REGIONS = new Set(["KZ", "BY", "AM", "GE", "AZ", "TJ", "MD", "UA"]);
/** Languages of those countries: Kazakh, Belarusian, Armenian, Georgian, Azerbaijani, Tajik, Ukrainian. */
const RUSSIAN_LANGUAGES = new Set(["kk", "be", "hy", "ka", "az", "tg", "uk"]);

/**
 * A shipped language wins; otherwise the CIS countries listed above get
 * Russian and everyone else English.
 */
export function detectLocale(language: string | undefined = globalThis.navigator?.language): Locale {
  const parts = (language ?? "en").split(/[-_]/);
  const code = (parts[0] ?? "en").toLowerCase();
  const region = parts.find((p, i) => i > 0 && p.length === 2)?.toUpperCase();
  if (SUPPORTED.has(code)) return code as Locale;
  if ((region && RUSSIAN_REGIONS.has(region)) || RUSSIAN_LANGUAGES.has(code)) return "ru";
  return "en";
}
